import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import { Button } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

export default function SelectableButton({
  children,
  checked = false,
  onClick = () => {},
  hideCheckBox = false,
}) {
  const [checkedState, setCheckedState] = useState(checked);

  useEffect(() => {
    if (checked !== checkedState) setCheckedState(checked);
  }, [checked]);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setCheckedState(!checkedState);
    onClick();
  };

  return (
    <div style={{ flex: 1 }}>
      <Button
        variant={checkedState ? "contained" : "outlined"}
        onClick={handleClick}
        sx={{
          justifyContent: "flex-start", // Align contents to the start
          textAlign: "left", // Align text to the left
        }}
        size="small"
        fullWidth
        component="div">
        {!hideCheckBox && (checkedState ? <CheckBox /> : <CheckBoxOutlineBlank />)}
        {children}
      </Button>
    </div>
  );
}

SelectableButton.propTypes = {
  children: PropTypes.node,
  checked: PropTypes.bool,
  onClick: PropTypes.func,
  hideCheckBox: PropTypes.bool,
};
